<template>
    <div>
        Aba Local Entrega
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            msgs: [],
        }
    },
    components: {
    },
    created () {
    },
    methods: {
    },
}
</script>

<style lang="scss">
</style>

